import React from 'react';
import { useHistory } from 'react-router-dom';

import steps from '../../../../utils/steps.json';

import StepProgress from '../../../../components/StepProgress';
import Alert from '../../../../components/Alert';
import Button from '../../../../components/Button';

import { PageContainer, ContainerButton } from '../../../../styles/styles';
import { useSolicitacaoGuias } from '../../../../contexts/SolicitacaoGuias/context';

function AguardarAnalise() {
    const history = useHistory();
    const { dataNumReferencia } = useSolicitacaoGuias();

    const successTitle = 'Solicitação realizada com sucesso!';
    const successMessage = [<br />, `Número de Protocolo Gerado: ${dataNumReferencia}`, <br />, <br />];

    return (
        <PageContainer>
            <StepProgress steps={steps.solicitacaoGuias} activeStep={4} />
            <Alert type={3} title={successTitle} message={successMessage} />
            <ContainerButton>
                <Button id="backStep" type="secondary" onClick={() => history.push('/')}>
                    Acessar home
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    onClick={() => history.push('/dados_beneficiario/selecionar_solicitacao_guias')}
                >
                    Solicitação de Guias
                </Button>
            </ContainerButton>
        </PageContainer>
    );
}

export default AguardarAnalise;
